import gql from 'graphql-tag';

const PROFESSION_QUESTIONS_QUERY = gql`
  query ($professionKey: String!) {  
    questions(professionKey: $professionKey){
      questionKey
      questionId
    }
  }
`;

export default PROFESSION_QUESTIONS_QUERY;
